import { fdeProjectPath, fdeRoutes } from '@/frontend/features/Fde/routes'

export function projectMemorySourceUrl(projectId: string, path: string, revision?: string) {
  if (path.startsWith('whatsapp:')) {
    return `/dashboard/discovery/project_whatsapp_sources/message?${new URLSearchParams({ project_id: projectId, source_ref: path })}`
  }
  return fdeProjectPath(fdeRoutes.material, projectId, { file: path, revision })
}
